module.exports = __webpack_public_path__ + "static/media/meh-regular.7183a892.svg";